export default "__VITE_ASSET__BPYmhTio__"